import React, { useState } from "react";
import "./WorkReport.css";
import downArrow from "../../shared/assets/icons/downArrow.png";
import backIcon from '../../shared/assets/icons/back.png';
import bellIcon from '../../shared/assets/icons/bell.png'; 
import micIcon from '../../shared/assets/icons/mic.png';
import { useNavigate, useParams } from 'react-router-dom';

const WorkReport = () => {
  const [expanded, setExpanded] = useState({
    spareParts: false,
    labour: false,
    workDone: false,
    photos: false,
  });

  const toggleSection = (section) => {
    setExpanded((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const toggleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };

    const navigate = useNavigate();
    const { id } = useParams();


  return (
    <div className="container">
      <header className="mobile-header" style={{backgroundColor:'#202941'}}>
  <div className="back-button" onClick={() => navigate(`/maintenancedetails/${id}`, { state: { status: 'closed' , feedbackStatus: 'notdone'} })}>
    <img src={backIcon} alt="Back" className="icon back-icon" />
  </div>
  <div className="main-mobile-header">
    <h2 className="main-title" style={{ fontSize: '20px', fontFamily: 'Montserrat' }}>Work Report Confirmation</h2>
    <p className="subtext" style={{ fontSize: '10px', fontFamily: 'Montserrat' }}>#1234567 | Abcd Technologies | Air Conditioner</p>
  </div>

  <div className="header-icons">
                  <img src={bellIcon} alt="Notifications"   className='notification-icon'/>
              </div>
</header>

     
     <div className="card" style={{margin:'0px', marginTop:'90px', fontSize:'16px',fontFamily: 'Montserrat'}}>
            <div className="card-header" onClick={() => toggleExpand("technician")}> 
              Technician <span>{expanded === "technician" ? <img src={downArrow} alt="Back" className="icon back-icon" />  : <img src={downArrow} alt="Back" className="icon back-icon" />}</span>
            </div>
            {expanded === "technician" && (
              <div className="card-content">
                <br />
                <p style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  Abcd Technologies
                  <span style={{ marginLeft: 'auto' }}>#1234567</span>
                </p>
            
                <hr style={{ border: '0.1px solid #FFFFFF', margin: '10px 0' }} />
            
                <p>John Doe</p>
                <br />
                <p>+91 8741497788</p>
                <br />
                <p>johndoe@gmail.com</p>
                <br />
                <p>258 Street, Palarivattom, Ernakulam, Kerala, India</p>
              </div>
            )}
          </div>

     <div className="card" style={{margin:'0px',  marginTop:'20px', fontSize:'16px',fontFamily: 'Montserrat'}}>
             <div className="card-header" onClick={() => toggleExpand("spare")}> 
               Spare Parts 
               <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', textAlign: 'right', marginLeft: 'auto' }}>
  
  <span style={{ fontSize: '0.8rem', fontWeight: '300' }}>Total</span>
  <span style={{ fontSize: '1rem', fontWeight: '500' }}>₹ 44,000.00</span>
</div>
<span style={{ margin: '0 5px' }}>{expanded === "spare" ? <img src={downArrow} alt="Back" className="icon back-icon" /> : <img src={downArrow} alt="Back" className="icon back-icon" />}</span>
</div>
             {expanded === "spare" && (
               <div className="card-content">
                   <div className="spare-parts-table">
                   <br />
              <div className="row header">
                <span>Cost</span>
                <span>Quantity</span>
                <span>Value</span>
              </div>
              <div className="row header">
                <span>Thermistor & si</span>
                <span>1 No's</span>
                <span>₹ 22,000.00</span>
              </div>
              <div className="row header">
                <span>Condenser Coil</span>
                <span>1 No's</span>
                <span>₹ 22,000.00</span>
              </div>
              <hr style={{ border: '0.1px solid #FFFFFF', margin: '10px 0' }} />
              <div className="row header">
                <h3>Total</h3>
                <span></span>
                <h3>₹ 44,000.00</h3>
              </div>
            </div>
               </div>
             )}
           </div>

<div className="card" style={{margin:'0px',  marginTop:'20px', fontSize:'16px',fontFamily: 'Montserrat'}}>
        <div className="card-header" onClick={() => toggleExpand("labour")}> 
        Labour  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', textAlign: 'right', marginLeft: 'auto' }}>
  
  <span style={{ fontSize: '0.8rem', fontWeight: '300' }}>Total</span>
  <span style={{ fontSize: '1rem', fontWeight: '500' }}>₹ 24.36</span>
</div>
<span style={{ margin: '0 5px' }}>{expanded === "spare" ? <img src={downArrow} alt="Back" className="icon back-icon" /> : <img src={downArrow} alt="Back" className="icon back-icon" />}</span>
</div>
        {expanded === "labour" && (
          <div className="card-content">
            <div className="spare-parts-table">
                   <br />
              <div className="row header">
                <span>Estimated Time:</span>
                <span>Cost</span>
              </div>
              <div className="row header">
                <span>16:00:00</span>
                <span> ₹ 24.36</span>
              </div>
              <hr style={{ border: '0.1px solid #FFFFFF', margin: '10px 0' }} />
              <div className="row header">
                <h3>Total</h3>
                <span></span>
                <h3>₹ 24.36</h3>
              </div>
              </div>
            
          </div>
        )}
      </div>
           <div className="card" style={{margin:'0px', marginTop:'20px', fontSize:'16px',fontFamily: 'Montserrat'}}>
             <div className="card-header" onClick={() => toggleExpand("workDone")}> 
             Work Done <span>{expanded === "workDone" ? <img src={downArrow} alt="Back" className="icon back-icon" /> : <img src={downArrow} alt="Back" className="icon back-icon" />}</span>
             </div>
             {expanded === "workDone" && (
               <div className="card-content">
                   <br />
                 <p>• Cleaned the condenser coils.</p>
                 <br />
                 <p>• Cleaned the condenser coils.</p>
                 <br />
               </div>
             )}
           </div>
       
           <div className="card" style={{margin:'0px', marginTop:'20px', fontSize:'16px',fontFamily: 'Montserrat'}}>
             <div className="card-header" onClick={() => toggleExpand("photos")}> 
             Click to view photos <span>{expanded === "photos" ? <img src={downArrow} alt="Back" className="icon back-icon" /> : <img src={downArrow} alt="Back" className="icon back-icon" />}</span>
             </div>
             {expanded === "photos" && (
             <div className="card-conten">
              <div className="photo-grid"></div>
              <br />
              <div className="photo"></div>
              <br />
               </div>
               
             )}
           </div>


     
           <br />
           <hr style={{ border: '0.1px solid #FFFFFF', margin: '15px 0' }} />     
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20, marginBottom: 20 }}>
        <h3 style={{ textAlign: 'left' }}>Grand Total:</h3>
        <h3 style={{ textAlign: 'right' }}>₹ 44,024.36</h3>
      </div>
      <hr style={{ border: '0.1px solid #FFFFFF', margin: '15px 0' }} />
    
      <br />

        <div className="card " style={{margin:'0px',  marginTop:'20px', fontSize:'16px',fontFamily: 'Montserrat'}}>
        <div className="form">
        <label  style={{ fontSize:'16px',fontFamily: 'Montserrat'}}>For <span className="bold"> &nbsp;Abcd Technologies</span></label>
        </div>
        <div className="form-group">
          
          <input
        type="text"
        id="equipment"
        placeholder="Name*"
        style={{ width: '100%', fontFamily: 'Montserrat', fontSize: '16px', height: '40px' ,marginTop:'20px'}}
          />
        </div>
               <div className="form-group" >
                    <input 
                      id="remarks"
                     type="text"
                      placeholder="Remark's"
                      style={{ width: '100%', fontFamily: 'Montserrat', fontSize: '16px', height: '40px' ,marginTop:'20px'}}
                      
                    />
                      <img src={micIcon} alt="voice" className="icon add-icon" style={{ width: '25px', height: '25px', marginLeft: '0px' }} />

                  </div>
        <div className="signature-pad">
          <canvas id="signatureCanvas" width="425" height="200" style={{ border: '1px solid #000', backgroundColor: 'white' }}></canvas>
        </div>
      
      </div>

      

      <button className="submit-button"  onClick={() => navigate(`/maintenancedetails/${id}`, { state: { status: 'closed' } })}>Submit</button>
    </div>
  );
};

export default WorkReport;
